var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9 34.55c.53.18.81.78.64 1.34a7.1 7.1 0 0 1-6.82 4.86 7.3 7.3 0 0 1-5-1.96 1.1 1.1 0 0 1-.07-1.5.98.98 0 0 1 1.43-.08c.92.86 2.2 1.41 3.64 1.41a5.06 5.06 0 0 0 4.89-3.4 1 1 0 0 1 1.28-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.44 17.75C8.44 9.29 15.4 2 23.97 2S39.5 8.76 39.5 17.75v1.32h.3c3.46 0 6.2 3.01 6.2 6.66 0 3.65-2.74 6.67-6.2 6.67h-.34C38.86 39.94 32.1 46 23.97 46S9.08 39.94 8.48 32.4H8.2c-3.45 0-6.2-3.02-6.2-6.67s2.75-6.66 6.2-6.66h.24v-1.32Zm15.53 26.12c-7.5 0-13.5-5.85-13.5-12.55h7.8c1.08 0 2.12-.4 2.94-1.13a4.38 4.38 0 0 1 5.86 0 4.41 4.41 0 0 0 2.94 1.13h7.45c0 6.7-6 12.55-13.49 12.55ZM8.44 21.2H8.2c-2.27 0-4.17 2-4.17 4.53 0 2.54 1.9 4.54 4.17 4.54h.24V21.2Zm31.06 9.07h.3c2.27 0 4.17-2 4.17-4.54 0-2.53-1.9-4.53-4.17-4.53h-.3v9.07Zm-18.39-9.6c0-4.53-5.37-4.53-5.37 0v1.06c0 4 5.37 4 5.37 0v-1.06Zm10.9 0c0-4.53-5.37-4.53-5.37 0v1.06c0 4 5.37 4 5.37 0v-1.06Zm-5.34-6.87c1.58 0 2.32-2.03 1.15-3.14l-1.59-1.49 1.34-1.29c1.17-1.14.4-3.2-1.2-3.2L24 7.48l-2.39-2.8c-1.58 0-2.34 2.05-1.17 3.18l1.38 1.31-1.61 1.51c-1.18 1.1-.44 3.12 1.13 3.12L24 10.88l2.68 2.92Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxers);
export default __webpack_public_path__ + "static/media/uxers.c93ccff52bc3fdeeafbdf6cd8981be79.svg";
export { ForwardRef as ReactComponent };